import React from 'react';

export default () => <span style={{ color: '#d9534f' }}>*</span>;
